import React from 'react'
import DashboardTable from '../DashboardTable.component'
import { fluorideTrtmntData } from '../DashboardMockData'
import { computeIncome, formatValueByUnit } from '@utils/index'
import { Data, roleTemplate, simpleColTemplate } from './Production.component'

function FluorideTreatment(): React.ReactElement {
  const totalFluoride = (field: string): number => {
    return fluorideTrtmntData.reduce(
      (acc: number, item: any) => acc + item[field],
      0,
    )
  }
  const fluorideColTemplate = (datum: Data): React.ReactElement => {
    const income = computeIncome(datum.fluorideTreatment, datum.prevTreatment)
    const isIncomeDown = income < 1
    return (
      <>
        <div className="mb-2">Collections</div>
        <div className="fs-1 mb-2">
          {formatValueByUnit(datum.fluorideTreatment, '%')}
        </div>
        <div>
          <i
            className={`bi ${
              isIncomeDown
                ? 'bi-arrow-down-circle-fill'
                : 'bi-arrow-up-circle-fill'
            } me-1`}
          ></i>
          {`${isIncomeDown ? 'Down' : 'Up'} ${Math.abs(income).toFixed(0)}% from the previous week`}
        </div>
      </>
    )
  }

  const columns = [
    {
      field: 'role',
      header: 'Provider Totals',
      template: roleTemplate,
      width: '100',
    },
    {
      field: 'fluorideTreatment',
      header: 'Fluoride Treatment',
      template: fluorideColTemplate,
      headerTemplate: () =>
        simpleColTemplate(
          'Fluoride Treatment',
          totalFluoride('fluorideTreatment'),
          '%',
        ),
      width: '200',
    },
    {
      field: 'totalTreatment',
      header: 'Total Treatment',
      template: (datum: Data) =>
        simpleColTemplate('Fluoride Treatment', datum.totalTreatment, '#'),
      headerTemplate: () =>
        simpleColTemplate(
          'Total Treatment',
          totalFluoride('totalTreatment'),
          '#',
        ),
      width: '100',
    },
    {
      field: 'totalVisits',
      header: 'Total Visits',
      template: (datum: Data) =>
        simpleColTemplate('Hygiene Visit', datum.totalVisits, '#'),
      headerTemplate: () =>
        simpleColTemplate('Total Visits', totalFluoride('totalVisits'), '#'),
      width: '150',
    },
  ]

  return (
    <div>
      <DashboardTable
        title={'Collection'}
        columns={columns}
        data={fluorideTrtmntData}
        allowMultiSorting={false}
        allowSorting={false}
      />
    </div>
  )
}

export default FluorideTreatment
